import React from 'react';
import { connect } from 'react-redux';
import { uploadFilesNewEad, setIsSavingNewEad, updateAttachments } from '../../app/app.actions';

class UploadContainer extends React.Component {
    constructor(props) {
        super(props);
        this.refInputUpload = React.createRef();
        this.state = {
            currentAttachments: this.props.files || [],
        };
    }

    handlerUpload = () => {
        const { current } = this.refInputUpload;
        if (current) {
            current.click();
        }
    }

    onChangeInput = (event) => {
        let files = event.target.files;
        if (files.length > 0) {
            this.props.setIsSavingNewEad(true);
            let fileData = new Blob([files[0]]);
            // eslint-disable-next-line
            function getBuffer(resolve) {
                var reader = new FileReader();
                reader.readAsArrayBuffer(fileData);
                reader.onload = function () {
                    var arrayBuffer = reader.result;
                    var bytes = new Uint8Array(arrayBuffer);
                    resolve(bytes);
                };
            }

            let promise = new Promise(getBuffer);
            const payload = {
                dataUri: [],
                mime: files[0].type,
                newFile: {
                    name: files[0].name,
                    type: this.props.currentType,

                },
            };

            promise.then((data) =>{
                payload.dataUri = data;
                this.props.uploadFilesNewEad(payload);
                this.setState({ ...this.state, isSaving: false });
            }).catch(function(err) {
                throw err;
            });

            if (this.refInputUpload.current) {
                this.refInputUpload.current.value = '';
            }
        }
    }

    handlerDelete(url) {
        this.props.setIsSavingNewEad(true);
        const { currentTccs } = this.props;

        let actualFiles = currentTccs.attachments || [];

        let newAttachments = actualFiles.filter(e=> e.url !== url);

        this.props.updateAttachments(newAttachments);
    }

    render() {
        const { files = [], isSaving, currentTccs, readOnly = false } = this.props;
        return (
            <div className='upload-container' >
                <div className='container-buttons-options' >
                    {!readOnly &&
                        <button
                            disabled={isSaving}
                            title='Salvar alterações' className='activity-btn'
                            onClick={() => this.props.updateAttachments(currentTccs.attachments || [])}
                        >
                            {isSaving ? 'Salvando' : 'Salvar'}
                        </button>
                    }
                    <input ref={this.refInputUpload} readOnly={readOnly} disabled={readOnly} onChange={this.onChangeInput} style={{ display: 'None' }} type='file' id='myfile' name='myfile'></input>
                    {!readOnly &&
                        <button title='Anexar arquivo' onClick={this.handlerUpload} className='activity-btn' disabled={isSaving}>
                            <i className='fa fa-paperclip' />
                        </button>
                    }
                </div>
                {files.map((file, indexFile) => (
                    <div key={indexFile}>
                        <div className='archive' >
                            <a href={file.url} target='_blank' >{file.name}</a>
                            {!readOnly && <i
                                className='fa fa-trash'
                                onClick={() => this.handlerDelete(file.url)}
                                title='Remover anexo'
                            />}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

const mapStateToProps = ({ App }) => {
    return {
        isSaving: App.isSavingNewEad,
        currentTccs: App.currentTccs,
    };
};

export default connect(mapStateToProps, { uploadFilesNewEad, updateAttachments, setIsSavingNewEad })(UploadContainer);



// WEBPACK FOOTER //
// ./src/components/section/components/upload-container.js